import type { TFunction } from 'i18next'

export const getTranslations = (t: TFunction) => {
  const localizedBreadcrumbs = [
    {
      key: t('user.account'),
      name: 'account',
    },
    {
      key: t('profile.title'),
      name: 'profile',
    },
    {
      key: t('profile.password-title'),
      name: 'change-password',
    },
    { key: t('account.phone'), name: 'phone-number' },
    { key: t('profile.promo-codes'), name: 'promocodes' },
    { key: t('profile.language'), name: 'language' },
    { key: t('account.payment-methods'), name: 'payment-methods' },
    { key: t('profile.invoice-information'), name: 'invoice-information' },
    { key: t('profile.privacy'), name: 'privacy-settings' },
  ]
  return localizedBreadcrumbs
}
